<script setup lang="ts">

defineOptions({
  name: 'Example3'
});

// 硬币的正反  0为字面，1为图面
const coin1 = ref(0);

let timer;
const animationBox = ref();
const handleTransform = () => {
  // 防止1.5秒内重复点击
  if (timer) return;
  animationBox.value.classList.add('pic-box-animation');
  coin1.value = coin1.value === 0 ? 1 : 0;
  timer = setTimeout(() => {
    // 设置三个硬币的正反面
    animationBox.value.classList.remove('pic-box-animation');
    timer = null;

  }, 1500);
};

const coinContainer = ref();
const handleRotate = () => {
  // 防止1.5秒内重复点击
  if (timer) return;
  animationBox.value.classList.add('coin_animation');
  setTimeout(() => {
    coin1.value = coin1.value === 0 ? 1 : 0;
  }, 1500);
  timer = setTimeout(() => {
    animationBox.value.classList.remove('coin_animation');
    timer = null;

  }, 3000);
};

</script>

<template>
  <div class="pic-box" ref="animationBox">
    <!--      <div class="boxes" @click="handleTransform">-->
    <!--        <div class="box">-->
    <!--          <img :class="coin1 ? 'img-pic ' : 'img-text'" :src="coinPic" alt="">-->
    <!--          <img :class="coin1 ? 'img-text' : 'img-pic'" :src="coinText" alt="">-->
    <!--        </div>-->
    <!--      </div>-->
    <div class="coin_container" ref="coinContainer" @click="handleRotate">
      <div :class="coin1 ? 'coin_back' : 'coin_front'">
        <div class="c1"></div>
        <div class="c2"></div>
        <div class="c3"></div>
        <div class="c4"></div>
        <div class="image">
          <img class="head_image" src="@/assets/game/flipCoin/head.png" alt="">
        </div>
        <div class="head_text text text_upper">HEADS</div>
      </div>
      <div :class="coin1 ? 'coin_front' : 'coin_back'">
        <div class="c1"></div>
        <div class="c2"></div>
        <div class="c3"></div>
        <div class="c4"></div>
        <div class="image">
          <img class="tail_image" src="@/assets/game/flipCoin/tail.png" alt="">
        </div>
        <div class="tail_text text text_upper">TAILS</div>
      </div>
    </div>
    <!--    <div class="coin relative-position">-->
    <!--      <div class="absolute-center front">正面</div>-->
    <!--      <div class="absolute-center back">反面</div>-->
    <!--    </div>-->
  </div>
</template>

<style lang="scss" scoped>

.coin_container {
  width: 327px;
  height: 327px;
  cursor: pointer;
  border-radius: 50%;
  transform-style: preserve-3d;
  position: relative;
  top: 0;
  transition: transform 3s ease-in-out;
  -moz-backface-visibility: hidden;

  .coin_front,
  .coin_back {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    border-radius: 50%;
  }

  .coin_back {
    transform: rotateX(180deg);
  }

  .coin_front div,
  .coin_back div {
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    border-radius: 50%;
    overflow: hidden;
  }

  .coin_front div:nth-of-type(1),
  .coin_back div:nth-of-type(1) {
    //background: linear-gradient(138.4deg, #4f0bb2 16%, #f71183 114%);
    z-index: 1;
    top: 0%;
    left: 0%;
  }


  .coin_front div:nth-of-type(2),
  .coin_back div:nth-of-type(2) {
    //background: linear-gradient(338deg, #7844c5 16%, #d975a6 114%);
    z-index: 2;
    width: 98%;
    height: 98%;
    top: 1%;
    left: 1%;
  }

  .coin_front div:nth-of-type(3),
  .coin_back div:nth-of-type(3) {
    background: linear-gradient(121.59deg, #ffe695 60%, #ffffff 100%);
    z-index: 3;
    width: 90%;
    height: 90%;
    top: 5%;
    left: 5%;
  }

  .coin_front div:nth-of-type(4),
  .coin_back div:nth-of-type(4) {
    //background: linear-gradient(326deg, #b684ff 16%, #fdbcdc 114%);
    z-index: 4;
    width: 84%;
    height: 84%;
    top: 8%;
    left: 8%;
  }

  .coin_front div:nth-of-type(5),
  .coin_back div:nth-of-type(5) {
    z-index: 5;
    width: 84%;
    height: 84%;
    top: 8%;
    left: 8%;
    background-color: transparent;
    border-radius: 50%;
  }

  .coin_front .image,
  .coin_back .image {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .coin_front .image img,
  .coin_back .image img {
    height: 100%;
    user-select: none;
  }

  .coin_front div:nth-of-type(6),
  .coin_back div:nth-of-type(6) {
    width: 120px;
    height: 50px;
    z-index: 6;
    font-size: 30px;
    font-weight: 800;
    top: 70%;
    left: 30%;
    color: rgba(255, 255, 255, 0.5);
    //text-shadow: -5px 4px 15px rgba(0, 0, 0, 0.25);
    border-radius: 0px;
    text-align: center;
    text-transform: uppercase;
    user-select: none;
  }


}

@keyframes container-animation {
  0% {
    transform: scale(1) rotateX(0deg);
    animation-timing-function: ease-in;
  }
  50% {
    transform: scale(1.4) rotateX(1890deg);
    animation-timing-function: ease-out;
  }
  //75% {
  //  transform: scale(1) rotateX(2700deg)
  //}
  100% {
    transform: scale(1) rotateX(3600deg)
  }
}

.coin_animation {
  .coin_container {
    animation: container-animation 3s ease-in 0s infinite;
  }
}


.coin {
  width: 100px;
  height: 100px;
  margin: 100px;
  animation: rotateCoin 3s linear infinite;
  //animation-iteration-count: 3;
  background-color: goldenrod;
  border-radius: 50%;

  .front {
    z-index: 1;
    background-color: goldenrod;
  }

  .back {
    z-index: 0;
  }
}

//.coin:hover {
//  animation-play-state: paused;
//}
@keyframes rotateCoin {
  0% {
    transform: rotateX(0deg);
  }
  100% {
    transform: rotateX(360deg);
  }
}

.pic-box {
  width: 100%;
  padding: 0 40px;
  display: flex;
  justify-content: space-between;

  .boxes {
    width: 190px;
    height: 190px;
    background: #00acc1;
  }

  .box {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    border-radius: 50%;

    .img-pic {
      width: 156px;
      height: 156px;
      position: absolute;
      top: 17px;
      left: 17px;
      z-index: 1;
      background: #23c100;
    }

    .img-text {
      width: 156px;
      height: 156px;
      position: absolute;
      top: 17px;
      left: 17px;
      z-index: 0;
      background: #23c100;
    }
  }
}

.pic-box-animation {
  .box {
    animation: box-animation .2s linear 0s infinite;

    .img-pic {
      animation: img-pic-animation .2s linear 0s infinite;
    }

    .img-text {
      animation: img-text-animation .2s linear 0s infinite;
    }
  }


  @keyframes box-animation {
    0% {
      transform: rotateX(0deg)
    }
    50% {
      transform: rotateX(180deg)
    }
    100% {
      transform: rotateX(360deg)
    }
  }

  @keyframes img-pic-animation {
    0% {
      z-index: 1;
    }
    50% {
      z-index: 0;
    }
    100% {
      z-index: 1;
    }
  }

  @keyframes img-text-animation {
    0% {
      z-index: 0;
    }
    50% {
      z-index: 1;
    }
    100% {
      z-index: 0;
    }
  }
}
</style>